const credentials = {
	guestUsername: 'info@onestoptechnologies.ca',
	guestPassword: '$uperDankSecurePassword'
};

export default credentials;
